import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Verify from "../../components/auth/Verify";
import useAuth from "../../hooks/useAuth";

export default function VerifyPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // If user is already authenticated, redirect to dashboard
    if (user) {
      navigate("/dashboard");
    }
  }, [user, navigate]);

  return <Verify />;
}
